import React from "react"

export function MenuItemLabel({ children }: { children: React.ReactNode }) {
  return <div className="leading-6" data-slot="menu-item-label">{children}</div>
}

MenuItemLabel.displayName = "Menu.ItemLabel"
